import {withStyles} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import {colors} from '../../helpers/colors'

const GreenSwitch = withStyles({
  root: {
    width: 52,
    height: 26,
    padding: 0,
    margin: 8,
  },
  switchBase: {
    padding: 1,
    color: colors.TEXT_MUTED,
    '&$checked': {
      transform: 'translateX(26px)',
      color: colors.TEXT_PRIMARY,
      '& + $track': {
        backgroundColor: colors.SUCCESS,
        opacity: 1,
        border: 'none',
        boxShadow: '0 0 12px rgba(34, 197, 94, 0.5)',
      },
    },
    '&$focusVisible $thumb': {
      color: colors.SUCCESS,
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    opacity: 1,
    transition: 'all 300ms ease',
  },
  checked: {},
  focusVisible: {},
})(Switch);

export default GreenSwitch;
